import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import SignupRoute from "./routes/signup";
import { ChakraProvider, Box } from "@chakra-ui/react";
import VicFormsRegistrationLayout from "./routes/vicformsRegistration";
import { vicformsTheme } from "./components/theme/vicformsTheme";
import { Global } from "@emotion/react";

export const App = () => (
  <ChakraProvider theme={vicformsTheme}>
    <Global
      styles={`
      @font-face {
        font-family: 'DM Sans';
        src: url('https://hutly-static-files-public-staging-4cc6d43d.s3.ap-southeast-2.amazonaws.com/emailAssets/dm-sans/DMSans-Regular.ttf') format('truetype');
      }
      @font-face {
        font-family: 'DM Sans';
        src: url('https://hutly-static-files-public-staging-4cc6d43d.s3.ap-southeast-2.amazonaws.com/emailAssets/dm-sans/DMSans-Bold.ttf') format('truetype');
        font-weight: bold;
      }
      `}
    />
    <Box bg="brand.100">
      <Router>
        <Switch>
          <Route path="/signup">
            <SignupRoute />
          </Route>

          <Route path="/vicforms/register">
            <VicFormsRegistrationLayout />
          </Route>

          <Redirect from="/" to="/vicforms/register" />
        </Switch>
      </Router>
    </Box>
  </ChakraProvider>
);
